import React, { useEffect, useState } from "react";
import { Box, TextField } from "@mui/material";
import DocumentUpload from "components/UI/documentUpload/DocumentUpload";
import AdvancedInputField from "components/UI/AdvancedInputField/AdvancedInputField";

const TextFieldQue = ({
  submittedAnswer,
  responseAnswer,
  isFrom,
  handleQuesAnswer,
  event,
  comment,
  linkageAnswer,
  question,
  hasAttachedDocument,
}) => {
  const [inputValue, setInputValue] = useState("");
  const [commentBox, setCommentBox] = useState("");
  const [attachDocument, setAttachDocument] = useState(null);

  // Initialize state only once on mount
  useEffect(() => {
    if (submittedAnswer && submittedAnswer.length > 0) {
      setInputValue(submittedAnswer?.[0]?.value || "");

      setCommentBox(submittedAnswer?.[0]?.comment || "");
      setAttachDocument(submittedAnswer[0]?.supporting_document || null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (field, value) => {
    if (field === "input") {
      setInputValue(value);
      if (isFrom === "taskSection") {
        handleQuesAnswer({
          obj: {
            value,
            comment: commentBox,
            weight: 1,
            supporting_document: attachDocument,
          },
          realQuestion: question,
        });
      }
    } else if (field === "comment") {
      setCommentBox(value);
      if (isFrom === "taskSection") {
        handleQuesAnswer({
          obj: {
            value: inputValue,
            comment: value,
            weight: 1,
            supporting_document: attachDocument,
          },
          realQuestion: question,
        });
      }
    } else if (field === "document") {
      setAttachDocument(value);
      if (isFrom === "taskSection") {
        handleQuesAnswer({
          obj: {
            value: inputValue,
            comment: commentBox,
            weight: 1,
            supporting_document:
              field === "document" && value === null ? value : attachDocument,
            document: field === "document" ? value : attachDocument,
            documentMetaData:
              field === "document"
                ? {
                    ques_id: question?._id,
                    name: value?.name,
                    is_supporting_document: true,
                    type: value?.type,
                  }
                : null,
          },
          realQuestion: question,
        });
      }
    }
  };

  const placeholderSize = {
    inputProps: { sx: { fontSize: "14px" } },
  };

  const labelSize = { style: { fontSize: "14px" } };

  return (
    <Box
      sx={{
        pointerEvents: isFrom === "publishedSurvey" ? "none" : "auto",
      }}
    >
      <AdvancedInputField
        data={inputValue}
        placeholder="Type your text here"
        name="input"
        handleChange={({ name, value }) => handleChange(name, value)}
      />

      {comment && (
        <Box style={{ pointerEvents: event, marginTop: "10px" }}>
          <AdvancedInputField
            data={commentBox}
            placeholder="Contributor’s comment"
            name="comment"
            handleChange={({ name, value }) => handleChange(name, value)}
          />
        </Box>
      )}
      {hasAttachedDocument && (
        <Box style={{ pointerEvents: event, marginTop: "10px" }}>
          <DocumentUpload
            value={attachDocument}
            isFrom="surveyTask"
            handleChange={handleChange}
            question={"document"}
          />
        </Box>
      )}
    </Box>
  );
};

export default TextFieldQue;
